export default __webpack_public_path__ + "static/media/cert3.2602a37d.jpg";